var render = function render(){var _vm=this,_c=_vm._self._c;return _c('r-button',{attrs:{"icon":"edit"},on:{"click":_vm.edit}})
}
var staticRenderFns = []

export { render, staticRenderFns }